document.addEventListener("DOMContentLoaded", function() {
    var HigherEdSales = {
               "name"   : "Higher Education Sales",
               "title"  : "",
               "phone"  : "(800) 747-4457 ext. 7548",
               "fax"    : "(217) 351-2674",
               "email1" : "highered@hkusa.com",
  };
  var BillDobrik = {
               "name"   : "Bill Dobrik",
               "title"  : "Senior Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7836",
               "fax"    : "(217) 351-2674",
               "email1" : "BillD@hkusa.com",
  };
  
  var AprilSchum = {
               "name"   : "April Schum",
               "title"  : "Higher Education Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7635",
               "fax"    : "(217) 351-2674",
               "email1" : "AprilS@hkusa.com",
  };
 
  var KariTestory = {
               "name"   : "Kari Testory",
               "title"  : "Sales Director",
               "phone"  : "(800) 747-4457 ext. 7609",
               "fax"    : "(217) 351-2674",
               "email1" : "karit@hkusa.com",
  };
  
  var NeilHollwedel = {
               "name"   : "Neil Hollwedel",
               "title"  : "Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7893",
               "fax"    : "(217) 351-2674",
               "email1" : "neilh@hkusa.com",
  };
  var BradHauser = {
               "name"   : "Brad Hauser",
               "title"  : "Senior Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7848",
               "fax"    : "(217) 351-2674",
               "email1" : "bradh@hkusa.com",
  };
  var MerryBlakey = {
               "name"   : "Merry Blakey",
               "title"  : "Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7724",
               "fax"    : "(217) 351-2674",
               "email1" : "merryb@hkusa.com",
  };
  var AmberBlazek = {
               "name"   : "Amber Blazek",
               "title"  : "Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7776",
               "fax"    : "(217) 351-2674",
               "email1" : "amberb@hkusa.com",
  };
  var TySweatman = {
               "name"   : "Ty Sweatman",
               "title"  : "Senior Sales Manager",
               "phone"  : "(800) 747-4457 ext. 7794",
               "fax"    : "(217) 351-2674",
               "email1" : "tys@hkusa.com",
  };
    // Define other sales rep objects...

    var stateArray = [
  {
       "Alabama": [
         BillDobrik
       ],"Alaska": [
         AprilSchum
       ],"Arizona": [
         NeilHollwedel
       ],"Arkansas": [
         NeilHollwedel
       ],"California": [
         TySweatman
       ],"Colorado": [
         NeilHollwedel
       ],"Connecticut": [
         AmberBlazek
       ],"Delaware": [
         BradHauser
       ],"District Of Columbia": [
         BradHauser
       ],"Florida": [
         BillDobrik
       ],"Georgia": [
         BillDobrik
       ],"Hawaii": [
         AprilSchum
       ],"Idaho": [
         AprilSchum
       ],"Illinois": [
         NeilHollwedel
       ],"Indiana": [
         TySweatman
       ],"Iowa": [
         HigherEdSales
       ],"Kansas": [
         AmberBlazek
       ],"Kentucky": [
         TySweatman
       ],"Louisiana": [
         NeilHollwedel
       ],"Maine": [
         AmberBlazek
       ],"Maryland": [
         BradHauser
       ],"Massachusetts": [
         AmberBlazek
       ],"Michigan": [
         TySweatman
       ],"Minnesota": [
         HigherEdSales
       ],"Mississippi": [
         BillDobrik
       ],"Missouri": [
         HigherEdSales
       ],"Montana": [
         AprilSchum
       ],"Nebraska": [
         AprilSchum
       ],"Nevada": [
         TySweatman
       ],"New Hampshire": [
         AmberBlazek
       ],"New Jersey": [
         AmberBlazek
       ],"New Mexico": [
         NeilHollwedel
       ],"New York": [
         AmberBlazek
       ],"North Carolina": [
         BradHauser
       ],"North Dakota": [
         AprilSchum
       ],"Ohio": [
         AmberBlazek
       ],"Oklahoma": [
         AmberBlazek
       ],"Oregon": [
         AprilSchum
       ],"Pennsylvania": [
         AmberBlazek
       ],"Rhode Island": [
         AmberBlazek
       ],"South Carolina": [
         BillDobrik
       ],"South Dakota": [
         AprilSchum
       ],"Tennessee": [
         BradHauser
       ],"Texas": [
         NeilHollwedel
       ],"Utah": [
         TySweatman
       ],"Vermont": [
         AmberBlazek
       ],"Virginia": [
         BradHauser
       ],"Washington": [
         AprilSchum
       ],"West Virginia": [
         BradHauser
       ],"Wisconsin": [
         HigherEdSales
       ],"Wyoming": [
         AprilSchum
       ],"Other Areas": [
         KariTestory
       ],"American Samoa": [
         AprilSchum
       ],"Guam": [
         AprilSchum
       ],"Puerto Rico": [
         AprilSchum
       ],"Virgin Islands": [
         AprilSchum
       ]
   }          
 ];

    function populateDropdown() {
      var dropDownState = document.getElementById("dropDownState");
      stateArray.forEach(function(states) {
        for (var state in states) {
          var salesReps = states[state];
          var option = document.createElement("option");
          option.value = state;
          option.setAttribute("data-salesRep", JSON.stringify(salesReps));
          option.innerHTML = state;
          dropDownState.appendChild(option);
        }
      });
    }

    function getSalesRepDets(dataArray, state) {
      var dets = '';
      dataArray.forEach(function(value) {
        dets += "<div class='col-md-6'>";
        dets += "<p class='salesRepTitle'><strong>" + state + "</strong></p>";
        if (value.name !== '') {
          dets += "<p class='sale-rep'>" + value.name + "<br>";
        }
        if (value.title !== '') {
          dets += value.title + "<br>";
        }
        if (value.phone !== '') {
          dets += "Telephone: "+ value.phone + "<br>";
        }
        if (value.fax !== '') {
          dets += "Fax: "+ value.fax + "<br>";
        }
        if (value.email1 !== '') {
          dets += "Email: <a href='mailto:"+value.email1+"' target='_top'>"+value.email1+"</a>";
        }
        // if (value.misc != undefined && != '') {
        //   dets += value.misc ;
        // }
        dets += "</div>";
      });
      return dets;
    }

    var dropDownState = document.getElementById("dropDownState");
    var salesRepElement = document.getElementById("salesRep");
    var showAllSalesRepsButton = document.getElementById("showAllSalesReps");

    populateDropdown();

    dropDownState.addEventListener("change", function() {
      var selectedOption = dropDownState.options[dropDownState.selectedIndex];
      var salesReps = selectedOption.getAttribute("data-salesRep");
      var dataArray = JSON.parse(salesReps);
      var selectedState = selectedOption.text;
      var dets = getSalesRepDets(dataArray, selectedState);
      showingAll = 0;
      salesRepElement.innerHTML = dets.trim();
    });

    var showingAll = 0;
    showAllSalesRepsButton.addEventListener("click", function() {
      var dets = '';
      dropDownState.value = "";

      if (showingAll === 0) {
        stateArray.forEach(function(states) {
          for (var state in states) {
            var dataArray = states[state];
            dets += getSalesRepDets(dataArray, state);
          }
        });
        salesRepElement.innerHTML = dets.trim();
        showingAll = 1;
      } else {
        salesRepElement.innerHTML = '';
        dropDownState.focus();
        showingAll = 0;
      }

    });
});
